'use client';

import { InvoiceSearchProps } from "./invoice-search.types";
import { SyntheticEvent, useRef, useState } from "react";
import { debounce } from "lodash";
import { PDFViewer } from "@/components/ui/pdf-viewer/pdf-viewer.component";
import { InvoiceExtended } from "@/types";
import { Logo } from "@/components/ui/logo";
import { Combobox } from "@/components/ui";
import { ComboboxOption } from "@headlessui/react";
import clsx from "clsx";
import { Search } from "lucide-react";

const InvoiceSearch: React.FC<InvoiceSearchProps> = ({
  onSelect
}) => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState<InvoiceExtended[]>([]);
  const searchValueRef = useRef<string>('');

  const handleInvoiceSearch = debounce(async(value: string) => {
    if (value) {
      const invoicesResponse = await fetch(`/api/invoice/search?query=${value}`);
      const invoicesList = await invoicesResponse.json();
      console.log('invoicesList', invoicesList);
      setSearchResults(invoicesList);
    } else {
      setSearchResults([]);
    }
    setIsSearching(false); // Update state after results are set
  }, 300); // Adjust debounce delay as needed


  const onInvoiceSearch = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    searchValueRef.current = value;
    setIsSearching(true); // Set searching state
    handleInvoiceSearch(value); // Debounce the search logic
  };

  const selectInvoice = (invoiceId: string) => {
    console.log('selected invoice', invoiceId);
    if(onSelect) onSelect(invoiceId);
  };


  return <div className="">
    <div className="max-w-[465px] max-h-[700px]">

      <Combobox 
        query={searchValueRef.current}
        onChange={(event) => onInvoiceSearch(event)}
        icon={<Search />}
        shouldOpenOnFocus={true}
        isLoading={isSearching ? 'Searching...' : undefined}
        placeholder="Search by Invoice ID, Seller Name..."
        items={searchResults.map((invoice: InvoiceExtended) => ({
          ...invoice,
          label: invoice.invoiceId,
          value: invoice.invoiceId,
          onClick: () => selectInvoice(invoice.id)
        }))}
        customItem={(item) => (
          <ComboboxOption
            onClick={() => selectInvoice(item.id)}
            value={item.invoiceId}
            className={clsx(
              'flex-col prose-paragraph-14-medium flex cursor-pointer select-none items-center gap-xs truncate whitespace-nowrap rounded-2xs px-xs py-xs text-foreground transition hover:bg-foreground hover:text-foreground focus:bg-foreground focus:text-foreground [&_svg]:size-5 [&_svg]:shrink-0',
              'rounded-xs gap-xs p-sm cursor-pointer hover:bg-foreground/5 data-[focus]:bg-foreground/5 data-[focus]:text-primary_hover',
              'hidden' in item && 'hidden'
            )}
          >
            <h3>{item.id}</h3>
            {item.seller ? <Logo url={item.seller.corporateWebsiteURL} shortName={item.seller.shortCompanyName} longName={item.seller.companyName} /> : null}
            {item.documentUrl ? <PDFViewer documentUrl={item.documentUrl} width={300} /> : null}
          </ComboboxOption>
        )} />
    </div>
  </div>
};

export { InvoiceSearch };